import { apiFetch, getAuthorizationHeaders } from 'utils/fetch';
import * as config from 'config';
import { Lwm2mFilter, Lwm2mResponse } from 'models/lwm2m';

export async function findRegistrations(
  filter: Lwm2mFilter[]
): Promise<Lwm2mResponse> {
  const headers = getAuthorizationHeaders();
  console.log(filter, 'not used');
  const url = `${config.backendApi}/lwm2m/registrations`; //?${filter[1].value}`;
  console.log('url');
  console.log(url);
  console.log(JSON.stringify(headers));
  return apiFetch<any>(url, { headers });
}
